import serverCall from "../serverCall";

const login = (email, password, login, type) => {
  try {
    const response = serverCall.post(
      `/auth/login?email=${email}&password=${password}&login=${login}&userLoginAs=${type}&isWebLogin=true`,
    );
    return response;
  } catch (error) {
    throw error;
  }
};

const AuthService = {
  login,
};

export default AuthService;
